// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/TemplatePage/styles.scss
// module id = 1132
// module chunks = 0